import { useQuery } from "@tanstack/react-query";
import API from "@/api";

function useObservationDates(nurseryId: string, queryParams?: URLSearchParams) {
  const { isPending, error, data } = useQuery({
    queryKey: ["observation-dates", nurseryId, queryParams?.toString()],
    queryFn: () => API.getObservationDates(nurseryId, queryParams)
  });

  return {
    isPending,
    error,
    data
  };
}

export default useObservationDates;
